<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Department"
      text="Update department"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localDepartment.id"
                v-validate="'required'"
                :items="departments"
                :error-messages="errors.collect('id')"    
                data-vv-name="id"
                data-vv-as="department"
                label="Department"
                item-text="name"
                item-value="id"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localSection.id" 
                :items="filteredSections"
                label="Section"
                item-text="name"
                item-value="id"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="effectiveDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="effectiveDate"
                    v-validate="'required'"
                    label="Effective Date"
                    :error-messages="errors.collect('effectiveDate')"
                    data-vv-name="effectiveDate"  
                    data-vv-as="effective date"      
                    readonly
                    class="fix-date-picker-outline-overlap"
                    outlined
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="effectiveDate"
                  @input="effectiveDateMenu = false"
                />
              </v-menu>
              <p
                v-if="$moment(effectiveDate).diff($moment()) >= 0"
                class="warning--text"
              >
                By selecting a future date, the details will only save when it reach the date
              </p>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      department: {
        type: Object,
        default: null,
      },
      section: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localDepartment: null,
        localSection: null,
        departments: [],
        loading: false,
        effectiveDateMenu: null,
        effectiveDate: null,
      }
    },
    computed: {
      filteredSections () {
        return this.departments.find(department => {
          return department.id === this.localDepartment.id
        }).sections
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loading = true

        this.localDepartment = { ...this.department }
        this.localSection = { ...this.section }
       
        this.$api.hrisDepartments().list()
          .then(res => {
            this.departments = res.data

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.jobDetails().update(this.employeeUid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: 'Employee department updated' })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          department_id: this.localDepartment.id,
          section_id: this.localSection.id,
          effective_date: this.effectiveDate,
        }
      },
    },
  }
</script>

<style scoped>
.fix-date-picker-outline-overlap >>> label{
  background: white;
  padding-right:10px
}
</style>
